module.exports = __webpack_public_path__ + "static/media/artist-production.8ba3db4b.jpeg";